import { Injectable } from '@angular/core';
import {HttpClientService} from "./http-client.service";
import {AppConfigService} from "./app-config.service";

@Injectable()

export class AuthenticationService {
  private apiUrl = AppConfigService.settings.apiUrl + 'auth/';  // URL to web api

  constructor(private http: HttpClientService) {}

  GetToken(): Promise<any[]> {
    return this.http.get(this.apiUrl)
      .toPromise()
      .then(response => response.json() as any[])
      .catch(this.handleError);
  }

  Authenticate(): Promise<any[]> {
    return this.http.get(this.apiUrl + 'validate')
      .toPromise()
      .then(response => response.json() as any[])
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication-service.service.ts